module.exports = __webpack_public_path__ + "img/74.625a5189.png";